import React from "react";
import Nav from "../Home/Nav/Nav";
import PageTop from "../../common/PageTop/PageTop";
import Footer from "../../common/Footer/Footer";
import Services from "../services/Services";
import aboutimage from '../../../assets/images/ogser.jpg'
import Features from "../Home/features/Features";

const ServicePage = () => {
  return (
    <>
      <Nav />
      <PageTop title={'What We Do'} image={aboutimage}/>
      <Features/>
      <Services />
      <Footer />
    </>
  );
};

export default ServicePage;
